import {
  ARBITRUM_CHAIN_ID_NUMBER,
  BASE_CHAIN_ID_NUMBER,
  BSC_CHAIN_ID_NUMBER,
  ETH_CHAIN_ID_NUMBER,
  MATIC_CHAIN_ID_NUMBER,
} from '../constants'

const stableCoinTickers: Record<number, string> = {
  [ETH_CHAIN_ID_NUMBER]: 'USDT',
  [BASE_CHAIN_ID_NUMBER]: 'USDT',
}
if (!Number.isNaN(BSC_CHAIN_ID_NUMBER)) {
  stableCoinTickers[BSC_CHAIN_ID_NUMBER] = 'BUSD'
}
if (!Number.isNaN(MATIC_CHAIN_ID_NUMBER)) {
  stableCoinTickers[MATIC_CHAIN_ID_NUMBER] = 'USDT'
}
if (!Number.isNaN(ARBITRUM_CHAIN_ID_NUMBER)) {
  stableCoinTickers[ARBITRUM_CHAIN_ID_NUMBER] = 'USDT'
}

const nativeCoinTickers: Record<number, string> = {
  [ETH_CHAIN_ID_NUMBER]: 'ETH',
  [BASE_CHAIN_ID_NUMBER]: 'ETH',
}
if (!Number.isNaN(BSC_CHAIN_ID_NUMBER)) {
  nativeCoinTickers[BSC_CHAIN_ID_NUMBER] = 'BNB'
}
if (!Number.isNaN(MATIC_CHAIN_ID_NUMBER)) {
  nativeCoinTickers[MATIC_CHAIN_ID_NUMBER] = 'POL'
}
if (!Number.isNaN(ARBITRUM_CHAIN_ID_NUMBER)) {
  nativeCoinTickers[ARBITRUM_CHAIN_ID_NUMBER] = 'ETH'
}

export const getStableCoinTickerByChainId = (chainId: number): string =>
  stableCoinTickers[chainId]

export const getNativeCoinTickerByChainId = (chainId: number): string =>
  nativeCoinTickers[chainId]
